<template>
  <div id="app">
    <Header></Header>
    <!-- <transition mode="out-in" enter-active-class="animated bounceInLeft" leave-active-class="animated backOutRight"> -->
    <!-- <transition mode="out-in" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"> -->
    <!-- <transition name="fade"> -->
      <router-view />
    <!-- </transition> -->
    <!-- <GoTop v-show="this.$route.name === 'HelloWorld' || this.$route.name === 'AboutUs'"></GoTop> -->
    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from './common/Header'
import GoTop from './common/GoTop'
import Bottom from './common/Bottom'
export default {
  name: 'App',
  components: {
    Header,
    GoTop,
    Bottom
  }
}
</script>

<style>
#app {
  font-family: 'MicrosoftYaHei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  position: relative;
  font-weight: 400;
  min-width: 1500px;
}
.clear{
  clear: both;
}
.fade-enter{
  visibility: hidden;
  opacity: 0;
}
.fade-leave-to{
  display: none;
}
.fade-enter-active,
.fade-leave-active{
  transition: opacity 2s ease;
}
.fade-enter-to,
.fade-leave{
  visibility: visible;
  opacity: 1;
}
.margin-b60{
  margin-bottom: 60px;
}
.text-indet2{
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue